<template>
  <div class="facet-element">
    <div v-for="option in options" class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        :id="`facet-cb-${name}-${option.key}`"
        :checked="isInContext(option)"
        :value="option.key"
        @change="updateContext(option)"
      >
      <label class="form-check-label" :for="`facet-cb-${name}-${option.key}`">
        {{ option.label }}
      </label>
      <facet-info-tooltip
        v-if="tooltip && tooltip[option.key]"
        :text="tooltip[option.key].text"
        :link-url="tooltip[option.key].linkUrl"
        :link-text="tooltip[option.key].linkText"
      />
    </div>
  </div>
</template>

<script>
import { store } from '../../../../store.js'
import FacetInfoTooltip from './FacetInfoTooltip.vue'

export default {
  name: "CheckBoxesType",
  components: { FacetInfoTooltip },
  props: ['name', 'options', 'tooltip'],
  data() {
    return {
      store,
    }
  },
  methods: {
    isInContext(option) {
      if(!this.store.context.hasOwnProperty(this.name) || this.store.context[this.name] === null) {
        return false;
      }

      return store.context[this.name].includes(option.key);
    },
    updateContext(option) {
       if(!this.store.context.hasOwnProperty(this.name)) {
         console.info('Could not find filter ', this.name);
         return
       }

       if (this.store.context[this.name] === null) {
         this.store.context[this.name] = [];
       }

       if(this.store.context[this.name].includes(option.key)) {
          this.store.context[this.name] = this.store.context[this.name].filter(key => key !== option.key)
       } else {
          this.store.context[this.name] = [ ...this.store.context[this.name], option.key ]
       }

       this.store.updateSearchResults(true);
    }
  }
}
</script>

<style scoped>

</style>
